import { AppBar, Box, Stack, Toolbar } from "@mui/material";
import { CustomLogo } from "../components/images/Logo";
import { Outlet } from "react-router-dom";

export const PublicLayout = () => {
  return (
    <>
      <AppBar
        position="sticky"
        color="default"
        sx={{
          background: "#F7F7F7",
          height: "74px",
          boxShadow: "0",
          px: 2,
          justifyContent: "center",
          top: 0,
        }}
      >
        <Toolbar>
          <Box>
            <CustomLogo />
          </Box>
        </Toolbar>
      </AppBar>
      <Stack
        sx={{
          px: { sm: 8, md: 8, lg: 10, xl: 20 },
          minHeight: "Calc(100vh - 74px)",
          paddingTop: 0,
        }}
        gap="40px"
      >
        <Outlet />
      </Stack>
    </>
  );
};
